import React, { PureComponent } from 'react';
import CalenderPanel from '../../../shared/calender/calender-panel';
import { GetProduct } from '../../../../actions/product';
import { withApollo } from 'react-apollo';
import ResponsiveImage from '../../../shared/responsiveImage';
import { connect } from 'react-redux';
import { renderDashedList } from '../../../../helpers/stringutils';
import { AddProduct } from '../../../../actions/booking';
import { bindActionCreators } from 'redux';
import { ToggleSlidingPanel } from '../../../../actions/utils';
import { productData } from '../../../../helpers/productHelper';
import ButtonSpinner from '../../../shared/UI/button-spinner';
import { ISOCurrencyCovert  } from '../../../../helpers/locationHelper';


class BuilderSlidePanel extends PureComponent {
   
   constructor(props){
      super(props);

      this.state = {
        contentPanelName:"main"
      }

      this.addTrip = this.addTrip.bind(this);
      this.closePanel = this.closePanel.bind(this)
   }

   componentDidMount(){
      document.body.addEventListener('BUILDER_SECTOR_CLICK', e => this.openPanel(e, e.detail) );

     //FOR TESTING ONLY
    //  const slidingPanel = document.querySelector(`[data-slide-panel=${this.state.contentPanelName}]`);
    //  slidingPanel.classList.add('js-panel--is-visible');
    //  GetProduct(this.props.client, "BOI", "GBP");
     //END OF TESTING
   } 
   
   componentWillUnmount(){
      document.body.removeEventListener('BUILDER_SECTOR_CLICK', this.openPanel);
   }

   openPanel(e, tourId){

      const { contentPanelName } = this.state;
      const { client, currentBooking:{iso_currency} } = this.props;

      e.preventDefault();

      const slidingPanel = document.querySelector(`[data-slide-panel=${contentPanelName}]`);

      //Open sliding panel on trigger button
      slidingPanel.classList.add('js-panel--is-visible');

      //Fix - remove double scrollbar 
      document.querySelector('body').classList.add('overflow-hidden');
      
      //Add close event listener
      slidingPanel.addEventListener('click', this.closePanel);

      //Fetch product info 
      GetProduct(client, tourId, iso_currency);
   }


   closePanel(e){
      const { ToggleSlidingPanel } = this.props;
      const { contentPanelName } = this.state;

      if(e !== null){ 
      
        e.preventDefault();
        
        //close panel on 'close button' or outside panel
        if(e.target.classList.contains('js-close-panel') || e.target.dataset.slidePanel === contentPanelName){
          document.querySelector(`[data-slide-panel=${contentPanelName}]`).classList.remove('js-panel--is-visible');
          document.querySelector('body').classList.remove('overflow-hidden');
          setTimeout(() => ToggleSlidingPanel(false, false, false), 300);
        }

      }else{
        document.querySelector(`[data-slide-panel=${contentPanelName}]`).classList.remove('js-panel--is-visible');
        document.querySelector('body').classList.remove('overflow-hidden');
        setTimeout(() => ToggleSlidingPanel(false, false, false), 300);
      }

   }

   addTrip(){

     const { client, currentBooking:{uuid}, departure_date, product:{name, tourId}, isLoading }  = this.props;

     if(!isLoading){
      AddProduct(client, uuid, tourId, 'product', departure_date, name, true).then(() => {
        this.closePanel(null);
      });
     }

   }

   
   render(){ 

      const { contentPanelName } = this.state;
      const { product, departure_date, isLoading, currentBooking:{iso_currency}  } = this.props;
      const { name, duration, mapImage, heroImage, startCity, endCity, price, includedList, hasOptions } = productData(product, iso_currency);

      return (
        <div className="js-panel js-panel--from-right" data-slide-panel={contentPanelName}>
          <div className="js-panel__container">
            <div className="js-panel__content">
                <div className="clearfix">
                    <div className="col col-12 px2 margin-b-80">
                        <button className="close-button js-close-panel" type="button"></button>
                    </div>
                </div>
                <div className="sliding-panel-info margin-b-100">
                    <div className="clearfix margin-b-70">
                        <div className="col col-12 px2">
                            <div className="sliding-panel-details">
                              <div className="clearfix">
                                  <div className="col col-12 sm-col-2 xs-hide">
                                    <ResponsiveImage 
                                        quality={70}
                                        src={heroImage}
                                        width={339}
                                        widthRetina={678}
                                        alt={"map"}
                                        clazz={"round-corners"}
                                        lazyload={false}
                                        />
                                  </div>
                                  <div className="col col-12 sm-col-10 pl2">
                                  <h2 className="pb2 pt1">{name}</h2>
                                  <p className="bold f-size-14 pb2">
                                      {duration} days {startCity}  to {endCity}
                                  </p>
                                  <p className="orange-text f-size-14">from <span className="bold">{ISOCurrencyCovert(iso_currency).props.children}{parseFloat(price).toFixed(2)} </span></p>
                                  
                                  </div>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix">
                        <div className="col col-12 sm-col-4 lg-col-5 px2">

                              <ResponsiveImage 
                                  quality={70}
                                  src={mapImage}
                                  width={139}
                                  widthRetina={139}
                                  alt={"map"}
                                  clazz={"round-corners"}
                                  lazyload={false}
                                  />

                              <ul className="sliding-panel-builder-list">
                                { renderDashedList(includedList).map((list, i)=> { return <li key={i}>{list}</li> }) }
                              </ul>
                

                        </div>
                        <div className="col col-12 sm-col-8 lg-col-7 px2">
                            <CalenderPanel isBuilder={true} clazz={""} showProductlist={hasOptions} />


                             <div className="clearfix">
                                <div className="margin-t-30 col-12 sm-col-6 mx-auto"> 
                                  <button className="busabout--cta orange rounded-corner full-width" onClick={this.addTrip} disabled={(departure_date === "" || isLoading) ? true : false}>
                                    { !isLoading && <>Add trip to booking</> }
                                    { isLoading && <ButtonSpinner clazz={"white"} /> } 
                                  </button>
                                </div>
                              </div> 
                           
                        </div>
                    </div>
                </div>
            </div>
          </div> 
      </div>
      )
   }
}


const mapStateToProps = state => {
    return{
      currentBooking:state.currentBooking,
      product:state.product,
      departure_date:state.cart.departure_date,
      isLoading:state.cart.update_sector_loading
    }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
      ToggleSlidingPanel
  }, dispatch);
}

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(BuilderSlidePanel)); 
  